import {UI} from "stem-core/src/ui/UIBase";
import {Card} from "../ui/Card";
import {SimpleTable} from "../../../../dashboard/ui/SimpleTable";
import {autoredraw} from "stem-core/src/decorators/AutoRedraw";
import {MerchantStaffStore} from "client/state/merchant/MerchantStaffStore";


@autoredraw(MerchantStaffStore)
export class MerchantStaffList extends UI.Element {
    render() {
        const {merchant} = this.options;

        const usersAccess = merchant.getUsersAccess();
        const accessTableColumns = [
            ["User", userAccess => userAccess.user.email],
            ["Is Owner", userAccess => userAccess.isOwner],
        ]

        return (
            <Card title="Dashboard access">
                <SimpleTable entries={usersAccess} columns={accessTableColumns}/>
            </Card>
        )
    }
}
